import { useEffect, useState } from "react";

import { useQuestions } from "./hooks/useQuestions";
import { getLayer } from "./utils";
import { QuestionPanel } from "./components/QuestionPanel";

import { BaseContainer } from "./components/BaseContainer";
import "./global.css";
import { useStorage } from "./hooks/useStorage";

function App() {
  const { data } = useQuestions();
  const { storage, setStorage } = useStorage();
  const [currLayer, setCurrLayer] = useState(storage);

  const [layer, setLayer] = useState(data["layer_0"]);
  const [key, setKey] = useState(0);

  const handleChangeKey = (k: number, l: number) => {
    setCurrLayer(l);
    setKey(k);
  };

  useEffect(() => {
    setLayer(data[getLayer(currLayer)]);
    setStorage(currLayer);
  }, [currLayer]);

  useEffect(() => {
    if (!layer) {
      setLayer(data[getLayer(666)]);
    }
  }, [layer]);

  return (
    <BaseContainer>
      <QuestionPanel
        layer={layer ?? []}
        index={key}
        changeKey={handleChangeKey}
      />
    </BaseContainer>
  );
}

export default App;
